// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__22gq-","options":"AnswerScale_options__2gHZb","selected":"AnswerScale_selected__18ISc"};